var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9286 6.90625H9.10714V2.125C9.10714 1.5383 8.62734 1.0625 8.03571 1.0625H6.96429C6.37266 1.0625 5.89286 1.5383 5.89286 2.125V6.90625H1.07143C0.479799 6.90625 0 7.38205 0 7.96875V9.03125C0 9.61795 0.479799 10.0938 1.07143 10.0938H5.89286V14.875C5.89286 15.4617 6.37266 15.9375 6.96429 15.9375H8.03571C8.62734 15.9375 9.10714 15.4617 9.10714 14.875V10.0938H13.9286C14.5202 10.0938 15 9.61795 15 9.03125V7.96875C15 7.38205 14.5202 6.90625 13.9286 6.90625Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5a0785206bac8541de11531ed31ad723.svg";
export { ForwardRef as ReactComponent };